import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { Card } from '../../components/chrome';
import ChallengeCreateForm from './ChallengeCreateForm';
import { SectionHeader } from '../../components/chrome';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
	toolbarTitle: {
		marginBottom: 15
	}
});

class ChallengeCreate extends Component {
	render() {
		const { classes } = this.props;

		return (
			<SectionHeader title="Create Challenge" backButton>
				<div style={{ marginTop: 24, marginBottom: 24 }}>
					<Grid container justify="center" spacing={24}>
						<Grid item xs={12} md={11} lg={10}>
							<Grid container justify="center" spacing={24}>
								<Grid item xs={12}>
									<Card>
										<Typography variant="h6" color="inherit" className={classes.toolbarTitle}>
											<span>Challenge Details</span>
										</Typography>
										<ChallengeCreateForm />
									</Card>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</SectionHeader>
		);
	}
}

ChallengeCreate.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ChallengeCreate);
